import EFPicture from 'elem/compCommon/EFPicture';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, useState, useRouter } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const IMG_MAP: any = {
        us: '',
        au: '_au',
        kr: '_kr',
    };
    const cards: any = [
        {
            img: `/responsive/picture/power-backup/3_1${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
            imgPad: `/responsive/picture/power-backup/3_1${IMG_MAP[locale] || IMG_MAP.us}_pad.jpg`,
            title: t('secC_list1_title'),
            desc: t('secC_list1_desc'),
        },
        {
            img: `/responsive/picture/power-backup/3_2${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
            imgPad: `/responsive/picture/power-backup/3_2${IMG_MAP[locale] || IMG_MAP.us}_pad.jpg`,
            title: t('secC_list2_title'),
            desc: t('secC_list2_desc'),
        },
        {
            img: `/responsive/picture/power-backup/3_3${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
            imgPad: `/responsive/picture/power-backup/3_3${IMG_MAP[locale] || IMG_MAP.us}_pad.jpg`,
            title: t('secC_list3_title'),
            desc: t('secC_list3_desc'),
        },
        {
            img: `/responsive/picture/power-backup/3_4${IMG_MAP[locale] || IMG_MAP.us}.jpg`,
            imgPad: `/responsive/picture/power-backup/3_4${IMG_MAP[locale] || IMG_MAP.us}_pad.jpg`,
            title: t('secC_list4_title'),
            desc: t('secC_list4_desc'),
        },
    ];

    const onMouseEnter = (k: number) => {
        if (k !== active) {
            setActive(k);
            const target = document.querySelector(`.power-backup-C .card${k} .card-text`) as HTMLUListElement;
            target.style.transition = 'none';
            target.style.opacity = '0';
            setTimeout(() => {
                target.style.transition = 'all 0.4s ease';
                target.style.opacity = '1';
            }, 600);
        }
    };

    return (
        <div id="power-backup-C" className={`power-backup-C ef-layer ${css['power-backup-C']}`}>
            <div className="text-box">
                <p className="title">{t('secC_title')}</p>
            </div>
            <ul className="card-box">
                {cards?.map((card: any, k: number) => (
                    <li className={`card card${k} ${k === active ? 'active' : ''}`} key={k} onMouseEnter={() => onMouseEnter(k)}>
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.title} />
                        </div>
                        <div className="card-text">
                            <p className="card-title">{card?.title}</p>
                            <p className="card-desc">{card?.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>

            <Swiper
                className="swiper-box"
                effect="fade"
                modules={[Scrollbar]}
                spaceBetween={16}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 25,
                    snapOnRelease: true,
                }}
            >
                {cards?.map((item: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="item-img">
                            <EFPicture src={item?.img} srcPad={item?.imgPad} alt={item?.title} />
                        </div>
                        <div className="item-text">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
